/**
 * Per-page-load cap on captured exceptions, covering the path the SDK's own
 * burst protection does not: manual `posthog.captureException()` calls (the
 * Vue error handler's path, wired up in PR 2 — see plan §3.7).
 *
 * The limit mirrors the SDK's burst-protection bucket size (plan §2), so the
 * manual-capture path isn't allowed materially more headroom per page load
 * than the autocaptured path already gets.
 */
export const DEFAULT_CEILING = 10;

/**
 * Returns a stateful `applyCeiling(event)` function: passes the first `limit`
 * calls through unchanged, then returns `null` for every call after.
 *
 * @param {number} [limit] Max calls to pass through before dropping the rest.
 * @returns {(event: object) => (object|null)} The stateful ceiling function.
 */
export function createExceptionCeiling(limit = DEFAULT_CEILING) {
    let count = 0;
    return function applyCeiling(event) {
        count += 1;
        return count <= limit ? event : null;
    };
}
